import { render } from "./Extraction.vue?vue&type=template&id=c4c347c8"
import script from "./Extraction.vue?vue&type=script&lang=js"
export * from "./Extraction.vue?vue&type=script&lang=js"

import "./Extraction.vue?vue&type=style&index=0&id=c4c347c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__